import axios from 'axios'
import router from './../../../router'
import {Errors, Form} from './../../../components/validations/forms.js'

const namespaced = true;

const state = {
  moduleGroups: [],
  modules: [],
  relatedModules: [],
  roles: [],
  permissions: [],
  relatedPermissions: [],
  actions: [],
  scopeTypes: [],
  scopes: [],
  users: [],

};

const getters = {
  getModuleGroups (state) {
    return state.moduleGroups
  },

  getModules (state) {
    return state.modules
  },

  getRelatedModules (state) {
    return state.relatedModules
  },

  getRoles (state) {
    return state.roles
  },

  getPermissions (state) {
    return state.permissions
  },

  getRelatedPermissions (state) {
    return state.relatedPermissions
  },

  getActions (state) {
    return state.actions
  },

  getScopeTypes (state) {
    return state.scopeTypes
  },

  getScopes (state) {
    return state.scopes
  },

  getUsers (state) {
    return state.users
  },
};


const mutations = {
  updateModuleGroups (state, payload) {
    state.moduleGroups = payload
  },

  updateModules (state, payload) {
    state.modules = payload
  },

  updateRelatedModules (state, payload) {
    state.relatedModules = payload
  },

  updateRoles (state, payload) {
    state.roles = payload
  },

  updatePermissions (state, payload) {
    state.permissions = payload
  },

  updateRelatedPermissions (state, payload) {
  state.relatedPermissions = payload
},

  updateActions (state, payload) {
    state.actions = payload
  },

  updateScopeTypes (state, payload) {
    state.scopeTypes = payload
  },

  updateScopes (state, payload) {
    state.scopes = payload
  },

  updateUsers (state, payload) {
    state.users = payload
  },
};


const actions = {

  fetchModuleGroups ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/security/module_group')
        .then(res => {
          commit('updateModuleGroups', res.data.data)
          console.log('fetchModuleGroups - Module Groups Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  fetchModules ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/security/module')
        .then(res => {
          commit('updateModules', res.data.data)
          console.log('fetchModules - Modules Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  fetchRelatedModules ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/security/related_module')
        .then(res => {
          commit('updateRelatedModules', res.data.data)
          console.log('fetchRelatedModules - Related Modules Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  fetchRoles ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/security/role')
        .then(res => {
          commit('updateRoles', res.data.data)
          console.log('fetchRoles - Roles Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  fetchPermissions ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/security/permission')
        .then(res => {
          commit('updatePermissions', res.data.data)
          console.log('fetchPermissions - Permissions Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  fetchRelatedPermissions ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.post('/api/security/related_module/permissions')
        .then(res => {
          commit('updateRelatedPermissions', res.data)
          console.log('fetchRelatedPermissions - Related Permissions Fetched.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  fetchActions ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/security/action')
        .then(res => {
          commit('updateActions', res.data.data)
          console.log('fetchActions - Actions Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  fetchScopeTypes ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/security/scope_type')
        .then(res => {
          commit('updateScopeTypes', res.data.data)
          console.log('fetchScopeTypes - Scope Types Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  fetchScopes ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/security/scope')
        .then(res => {
          commit('updateScopes', res.data.data)
          console.log('fetchScopes - Scopes Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  fetchUsers ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/security/user')
        .then(res => {
          commit('updateUsers', res.data.data)
          console.log('fetchUsers - Users Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  assignRoles ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.put('/api/security/user/'+payload.userID, {
        roleID: payload.roleID,
      })
        .then(res => {
          console.log('assignRoles - Roles Assigned.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  assignPermissions ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/security/permission', {
        moduleID: payload.moduleID,
        roleID: payload.roleID,
        scopeID: payload.scopeID,
        actionID: payload.actionID
      })
        .then(res => {
          console.log('assignPermissions - Permissions Assigned.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  saveRole ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/security/role', {
        name: payload.name,
      })
        .then(res => {
          console.log('saveRole - Roles Saved.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  saveRelatedPermissions ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/security/related_module/toggle', {
        actionID: payload.actionID,
        relationshipID: payload.relationshipID
      })
        .then(res => {
          console.log('saveRelatedPermissions - Related Permissions Saved.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/security/security.js